export default "__VITE_ASSET__Cgim9_rm__"